class FacetSubList extends HTMLElement {
  connectedCallback() {
    this.parentCheckbox = this.findParentCheckbox();

    if (!this.parentCheckbox) {
      return;
    }

    this.childCheckboxes = Array.from(this.querySelectorAll('input[type="checkbox"]'));

    this.onParentChange = this.handleParentChange.bind(this);
    this.onChildChange = this.handleChildChange.bind(this);

    this.parentCheckbox.addEventListener('change', this.onParentChange);
    this.childCheckboxes.forEach((checkbox) => checkbox.addEventListener('change', this.onChildChange));

    const anyChildChecked = this.childCheckboxes.some((checkbox) => checkbox.checked);

    if (this.parentCheckbox.checked && !anyChildChecked) {
      this.handleParentChange();
    } else {
      this.handleChildChange();
    }
  }

  disconnectedCallback() {
    if (!this.parentCheckbox) {
      return;
    }

    this.parentCheckbox.removeEventListener('change', this.onParentChange);
    this.childCheckboxes.forEach((checkbox) => checkbox.removeEventListener('change', this.onChildChange));
  }

  findParentCheckbox() {
    const form = this.closest('form');
    const name = this.getAttribute('parent-name');
    const value = this.getAttribute('parent-value');

    if (!form || !name || !value) {
      return null;
    }

    return Array.from(form.elements).find((element) => element.name === name && element.value === value) || null;
  }

  handleParentChange() {
    const checked = this.parentCheckbox.checked;

    this.parentCheckbox.indeterminate = false;

    this.childCheckboxes.forEach((checkbox) => {
      if (!checkbox.disabled) {
        checkbox.checked = checked;
      }
    });
  }

  handleChildChange() {
    const enabledCheckboxes = this.childCheckboxes.filter((checkbox) => !checkbox.disabled);
    const checkedCount = enabledCheckboxes.filter((checkbox) => checkbox.checked).length;

    if (checkedCount === 0) {
      this.parentCheckbox.checked = false;
      this.parentCheckbox.indeterminate = false;
    } else if (checkedCount === enabledCheckboxes.length) {
      this.parentCheckbox.checked = true;
      this.parentCheckbox.indeterminate = false;
    } else {
      this.parentCheckbox.checked = true;
      this.parentCheckbox.indeterminate = true;
    }
  }
}

if (!window.customElements.get('facet-sub-list')) {
  window.customElements.define('facet-sub-list', FacetSubList);
}
